var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaIconsDispatchStockToBjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.54,
    height: 18,
    viewBox: "0 0 15.54 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.063,8.951H148.44a.576.576,0,0,1-.577-.577V4.727h-.908A.581.581,0,0,1,146.5,3.8L149.3.219a.579.579,0,0,1,.908,0L153,3.8a.581.581,0,0,1-.454.931h-.908V8.374A.576.576,0,0,1,151.063,8.951Z",
    transform: "translate(-109.982 0)",
    fill: "#6396e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,154.623v6.535a.58.58,0,0,0,.35.531l7.243,3.093a.6.6,0,0,0,.454,0l7.147-3.093a.577.577,0,0,0,.346-.531v-6.439l-1.154.862v5.2L40.4,163.374v-5.512l6.77-2.577a.582.582,0,0,0-.008-1.081l-4.146-1.5-.4,1.081,2.689.973-5.485,2.089-5.574-2.108,2.535-.912-.388-1.085-4.012,1.439a.583.583,0,0,0-.008,1.085",
    transform: "translate(0 -146.826)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245,228.647l6.566-2.523-.077-5.924-6.439,2.177Z",
    transform: "translate(-204.807 -211.73)",
    fill: "#acacac"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaIconsDispatchStockToBjs);
export default __webpack_public_path__ + "static/media/ctaIcons_DispatchStockToBJS.0101834018e647b84e7aef5e6bc80b2b.svg";
export { ForwardRef as ReactComponent };